import { FormEvent, useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges, ReactFlowInstance} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { ModelSchemaWidget } from "./components/ModelSchemaWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-convert-node-configuration";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
    Button
} from '@mui/material';

export const WorkflowConvertNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleShowConvertModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    function duplicateNode(): void {
        if (formData !== undefined && formData.node_id !== undefined) {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result: string = "";
            for (let i: number = 0; i < 12; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            const currentNode: any = reactFlowInstance.getNode(formData.node_id);
            let duplicateNode: any = structuredClone(currentNode);
            duplicateNode.id = result;
            duplicateNode.position.x = duplicateNode.position.x + 200 || 300
            duplicateNode.position.y = duplicateNode.position.x + 200 || 300
            let nodes = reactFlowInstance.getNodes();
            let newNodes: any = [duplicateNode];
            for (const node of nodes) {
                newNodes.push(node);
            }
            context.updateLayoutNodes(newNodes);
        }

    }

    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'data_to_loop',
                    'latest_user_message',
                    'scraper_pending'
                ]
            },
        },
        'data_model_structure': {
            'ui:widget': 'ModelSchemaWidget'
        },
        'ui:order': [
            'data_input',
            'convert_type',
            'root_tag',
            'lowercase_tags',
            'force_array',
            'trim_whitespace',
            'skip_header',
            'include_attr_types',
            'data_model_structure',
            'data_management',
            'add_output_to_message'
        ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget,
        ModelSchemaWidget: ModelSchemaWidget
    }

    useEffect( (): void => {
        if (context.activeEditConvertNode !== undefined && context.activeEditConvertNode.data !== undefined) {
            setFormData(context.activeEditConvertNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showConvertModal }
            title={ "Convert Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditConvertNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    { (formData?.node_id !== undefined ) &&
                        <Button
                            onClick={ duplicateNode }
                            variant="contained"
                            color="warning"
                            type="button">
                            <ContentCopyIcon />
                            <span>{ "Duplicate" }</span>
                        </Button>
                    }
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );
}